"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFieldState = void 0;

var _generateDefaultListState = require("./generateDefaultListState");

var _generateDefaultFieldState = require("./generateDefaultFieldState");

var getFieldState = function getFieldState(field, initialValues, options) {
  var parentPath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  if (field.type === 'list') {
    return (0, _generateDefaultListState.generateDefaultListState)(field, initialValues, options, parentPath);
  }

  return (0, _generateDefaultFieldState.generateDefaultFieldState)(field, initialValues, options);
};

exports.getFieldState = getFieldState;